import React from 'react';
import { FiSun, FiMoon, FiMonitor } from 'react-icons/fi';
import { useTheme } from './ThemeProvider';

export default function ThemeToggle() {
  const { theme, setTheme } = useTheme();

  const nextTheme = () => {
    if (theme === 'light') setTheme('dark');
    else if (theme === 'dark') setTheme('system');
    else setTheme('light');
  };

  const Icon = theme === 'light' ? FiSun : theme === 'dark' ? FiMoon : FiMonitor;

  return (
    <button 
      onClick={nextTheme}
      className="p-2.5 rounded-xl bg-white/10 dark:bg-white/5 border border-gray-200 dark:border-gray-800 hover:bg-gray-50 dark:hover:bg-white/10 transition-all shadow-sm text-gray-700 dark:text-gray-300"
      title={`Theme: ${theme}`}
    >
      <Icon className="w-5 h-5" />
    </button>
  );
}